import React from 'react'
import { useDrag } from 'react-dnd';
import { MdDragIndicator } from "react-icons/md";

export default function Templates({element}) {

    const [{ isDragging }, drag] = useDrag(() => ({
        type: 'FORM_ELEMENT',
        item:  element ,
        collect: (monitor) => ({
          isDragging: monitor.isDragging(),
        }),
      }));
    
      const opacity = isDragging ? 0.4 : 1;
  return (
    <div ref={drag} style={{ opacity }} title={element?.panel_name} className='form-elements'>
        <MdDragIndicator/> {element.panel_name}
    </div>
  )
}
